import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EdlProficiencyPickerOptions } from '@edl-development/edl-common';
import { RubricResponse } from 'src/app/model/enum/rubric/rubric-response.enum';
import { ObservationLookUpTypes } from 'src/app/observations/helpers/observation-lookup-types/observation-lookup-types.helper';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
  selector: 'edl-proficiency-pill',
  templateUrl: './edl-proficiency-pill.component.html',
  styleUrls: ['./edl-proficiency-pill.component.scss']
})
export class EdlProficiencyPillComponent implements OnInit, OnChanges {
  @Input() teacherRatingValue: RubricResponse = RubricResponse.UNSELECTED;
  @Input() evaluatorRatingValue: RubricResponse = RubricResponse.UNSELECTED;
  @Input() resourceFile?: ResourceData = {};
  @Input() resourceFileKey?: string = '';

  public teacher!: EdlProficiencyPickerOptions;
  public evaluator!: EdlProficiencyPickerOptions;

  constructor() { }

  ngOnInit(): void {
    this.teacher = ObservationLookUpTypes.generateRubricResponse(this.teacherRatingValue, this.resourceFile, this.resourceFileKey);
    this.evaluator = ObservationLookUpTypes.generateRubricResponse(this.evaluatorRatingValue, this.resourceFile, this.resourceFileKey);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const teacherRatingValue = changes['teacherRatingValue']?.currentValue ?? this.teacherRatingValue;
    const evaluatorRatingValue = changes['evaluatorRatingValue']?.currentValue ?? this.evaluatorRatingValue;
    const resourceFile = changes['resourceFile']?.currentValue ?? this.resourceFile;
    const resourceFileKey = changes['resourceFileKey']?.currentValue ?? this.resourceFileKey;

    this.teacher = ObservationLookUpTypes.generateRubricResponse(teacherRatingValue, resourceFile, resourceFileKey);
    this.evaluator = ObservationLookUpTypes.generateRubricResponse(evaluatorRatingValue, resourceFile, resourceFileKey);
  }

  getEvaluatorLabel() {
    return `Supervisor Rating: ${this.evaluator.Title}`;
  }

  getTeacherLabel() {
    return `Employee Rating: ${this.teacher.Title}`;
  }
}
